import { Injectable } from '@angular/core';
import { LookupService } from './lookup.service';

declare var NSWPoint: any;
@Injectable({
  providedIn: 'root'
})
export class AddressService {
  private apiKey = null;
  constructor(lookupService: LookupService) {
    lookupService.getSetting('AddressApiKey').subscribe(d => this.apiKey = d.Result.SettingValue);
  }

  public loadAddressWidget(line1Id: string, container, setAddress: any) {
    const ctrl = document.getElementById(line1Id);
    if (!ctrl || !this.apiKey) {
      setTimeout(() => this.loadAddressWidget(line1Id, container, setAddress), 200);
      return;
    }
    const widget = NSWPoint.setupAddressWidget({
      apiKeyPredictive1: this.apiKey,
      apiKeyOthers: this.apiKey,
      selector: '#' + line1Id,
      onAddressValidated: fullAddress => {
        if (fullAddress && fullAddress.data && fullAddress.data.addressDetails) {
          let str = fullAddress.data.addressDetails.formattedAddress;
          str = str.substr(0,
            str.length - fullAddress.data.addressDetails.postcode.length - fullAddress.data.addressDetails.stateTerritory.length - 2);
          const arr = str.split(',');
          setAddress(container, ctrl, arr[0].trim(), arr[1].trim(),
            fullAddress.data.addressDetails.stateTerritory, fullAddress.data.addressDetails.postcode);
          ctrl.focus();
          ctrl.blur();
          ctrl.focus();
        }
      }
    });
    return widget;
  }
}
